import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './ErroredPayoutsListItem.scss';

export default class ErroredPayoutsListItem extends Component {
    static propTypes = {
        item: PropTypes.any
    };

    renderFirstLast(data) {
        const request = JSON.parse(data);

        const firstName = _.get(request, 'recipient.firstName') || '';
        const lastName = _.get(request, 'recipient.lastName') || '';

        return firstName || lastName ? `${firstName} ${lastName}` : 'No Name';
    }

    render() {
        const erroredPayout = this.props.item;

        return (
            <div className="errored-payout-list-item">
                <span className="errored-payout-name">{this.renderFirstLast(erroredPayout.request)}</span>
                <span className="errored-payout-error">{erroredPayout.errorReason}</span>
            </div>
        );
    }
}
